import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext"; // Import AuthContext
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation
import CoverImage from "../assets/CoverImage.png"; // Import your image
import CircularProgressBar from "./CircularProgressBar";
import api from "../utils/api";
import AccountSidebar from "./AccountSidebar";
import { Search, ChevronDown, MoreHorizontal, ChevronLeft, ChevronRight } from 'lucide-react'


const TrackOrder = () => {
  const { token } = useAuth();
  const [orderId, setOrderId] = useState(null);
  const [FutorderId, setFutOrderId] = useState(null);
  const [orderStatus, setOrderStatus] = useState(null);
  const [orders, setOrders] = useState([]);
  const [orderQuantity, setorderQuantity] = useState(0);
  const [isPollingStopped, setIsPollingStopped] = useState(false); // Track if polling is stopped
  const progress = orderStatus?.status === "finished"
    ? 100
    : Math.min(((orderStatus?.amount / orderQuantity || 0) * 100).toFixed(0), 100);

  const [searchQuery, setSearchQuery] = React.useState("");
  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 10;

  // Filter orders based on the search query
  const filteredOrders = orders.filter(
    (order) =>
      order.type.toLowerCase().includes(searchQuery.toLowerCase()) ||
      order.orderId.toString().includes(searchQuery.toLowerCase()) ||
      order.status.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Calculate total pages for pagination
  const totalPages = Math.ceil(filteredOrders.length / itemsPerPage);
  const [showCredentialPopup, setShowCredentialPopup] = useState(false);
  const [showBackupPopup, setShowBackupPopup] = useState(false);

  // Handle page change
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };


  const errorMessages = [
    "wrongBA",
    "wrongConsole",
    "notEnoughCoins",
    "wrongUserPass",
    "LoginFailedDeviceBan",
    "loginFailed",
    "Customer wrong credentials",
    "noTM",
    "Incorrect Credentials",
    "console",
  ];


  const navigate = useNavigate();

  const fetchOrders = async () => {
    if (!token) {
      console.error("No auth token found");
      return;
    }

    try {
      const response = await api.get("/orders", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data && response.data.length > 0) {
        const allOrders = response.data;
        const mostRecentOrder = allOrders[allOrders.length - 1];

        if (orderId !== mostRecentOrder.orderId.replace(/#/g, "")) {
          console.log("New order detected. Resetting polling...");
          setIsPollingStopped(false); // Reset polling for the new order
        }

        setOrders(allOrders);
        setOrderId(mostRecentOrder.orderId.replace(/#/g, ""));
        setOrderStatus(mostRecentOrder);
        setFutOrderId(mostRecentOrder._id);
        setorderQuantity(mostRecentOrder.quantity);
      } else {
        console.log("No orders found for the user.");
      }

    } catch (error) {
      console.error("Error fetching orders:", error.message);
    }
  };
  let intervalId;

  // Modified fetchOrderStatus to remove localStorage check
  const fetchOrderStatus = async () => {
    if (!orderId || isPollingStopped) return; // Skip if polling is stopped

    try {
      const payload = {
        orderID: orderId,
        externalID: 1,
        apiUser: "futcoinspot@gmail.com",
        apiKey: "2d6e28bc134a3357be0cf448509f5fa6",
      };

      const response = await api.post("/proxy-order-status", payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      const { amount, amountOrdered, status } = response.data;
      console.log("Fetched Order Status:", response.data);

      if ((amount > amountOrdered - 10 && amountOrdered > 0) && status === "finished") {
        console.log("Condition met: Stopping further polling...");
        clearInterval(intervalId); // Stop further polling
        setIsPollingStopped(true); // Mark polling as stopped

        console.log("Order status successfully updated to Completed.");
      }

      setOrderStatus((prev) => ({
        ...prev,
        ...response.data,
      }));
    } catch (error) {
      console.error("Error fetching or updating order status:", error.message);
    }
  };

  // Call fetchOrders only when the component mounts
  useEffect(() => {
    fetchOrders();
  }, [token]);

  // Start polling for order status if orderId is available
  useEffect(() => {
    if (!orderId) return;

    intervalId = setInterval(fetchOrderStatus, 60000);
    fetchOrderStatus();

    return () => clearInterval(intervalId);
  }, [orderId]);


  const handleViewDetails = (id) => {
    console.log("Navigating to order details for ID:", id);
    navigate(`/order-details/${id}`);
  };


  if (!token) {
    return <div className="p-6 bg-gray-900 text-white rounded-lg">User not authenticated.</div>;
  }
  return (
    <div className="flex">
      {/* Sidebar */}

      <AccountSidebar />

      {/* Main Content */}
      <div className="w-full lg:w-3/4 p-6  bg-[#191919]  text-white">
        {/* Top Section */}


        <div className="grid md:grid-cols-2 gap-6 mb-4">
          {orderStatus ? (
            <>
              <div className="border border-primary rounded-lg p-6 ">
                <div className="flex justify-between items-start mb-4">
                  <div>
                    <span className="bg-primary text-black px-3 py-1 mt-10 rounded text-sm">
                      {orderStatus.status === "entered" || orderStatus.status === "partlyDelivered"
                        ? "Processing"
                        : orderStatus.status === "finished"
                          ? "Completed"
                          : orderStatus.statFus?.toUpperCase()}
                    </span>

                    <div className="mt-4">
                      <div>Order ID: {orderStatus.orderId}</div>
                      <div className="text-gray-400">
                        {new Date(orderStatus.createdAt).toLocaleString()}
                      </div>
                      <div className="text-lg text-primary mt-2">• {orderStatus.quantity}K Coins</div>
                    </div>
                  </div>
                  <div className="relative w-24 h-24">
                    {/* <div className="absolute inset-0 border-4 border-gray-700 rounded-full"> */}
                    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                      <span className="text-2xl"> <CircularProgressBar progress={progress} /></span>

                    </div>
                    {/* </div> */}
                  </div>
                </div>

                <div className="flex flex-col lg:flex-row items-center lg:gap-10 mb-4">
                  {/* Popup for Incorrect Credentials */}
                  {showCredentialPopup && (
                    <>
                      <div className="fixed inset-0 z-50 lg:flex items-center justify-center hidden">
                        <div
                          className="absolute inset-0 bg-black bg-opacity-50"
                          onClick={() => setShowCredentialPopup(false)}
                        />
                        <div className="bg-red-600 text-white font-inter text-lg rounded-lg p-6 max-w-3xl relative z-10">
                          <button
                            className="absolute top-2 right-2 text-black hover:text-gray-700"
                            onClick={() => setShowCredentialPopup(false)}
                          >
                            ×
                          </button>
                          <h3 className="text-center font-inter text-[16px] font-bold mb-4">Incorrect Credentials - Please Update</h3>
                          <p className='font-inter text-lg'>
                            You've entered incorrect login details. Please update your email/password to proceed.
                          </p>
                          <span className="items-center justify-center flex">_______________</span>
                        </div>
                      </div>
                      <div
                        className="fixed inset-0 bg-black bg-opacity-50 z-40 "
                        onClick={() => setShowCredentialPopup(false)}
                      />
                      <div className="rounded-t-xl fixed bottom-0 left-0 right-0 bg-red-600 text-white p-14 z-50 lg:hidden">
                        <div className="max-w-md mx-auto">
                          <h3 className="text-white font-medium mb-2">Incorrect Credentials - Please Update</h3>
                          <p className="text-white text-md">
                            You've entered incorrect login details. Please update your email/password to proceed.

                          </p>
                          <div className='mr-10 ml-20 text-white mt-4'>________________________</div>
                        </div>
                      </div>
                    </>
                  )}

                  {/* Popup for Backup Code */}
                  {showBackupPopup && (
                    <>
                      <div className="fixed inset-0 z-50 lg:flex items-center justify-center hidden">
                        <div
                          className="absolute inset-0 bg-black bg-opacity-50"
                          onClick={() => setShowBackupPopup(false)}
                        />
                        <div className="bg-red-600 text-white font-inter text-lg rounded-lg p-6 max-w-3xl relative z-10">
                          <button
                            className="absolute top-2 right-2 text-black hover:text-gray-700"
                            onClick={() => setShowBackupPopup(false)}
                          >
                            ×
                          </button>
                          <h3 className="text-center font-inter text-[16px] font-bold mb-4">Wrong Backup Code - Please Update</h3>
                          <p className='font-inter text-lg'>
                            The backup code you entered is invalid. Please update it to continue.
                          </p>
                          <span className="items-center justify-center flex">_______________</span>
                        </div>
                      </div>
                      <div
                        className="fixed inset-0 bg-black bg-opacity-50 z-40 "
                        onClick={() => setShowBackupPopup(false)}
                      />
                      <div className="rounded-t-xl fixed bottom-0 left-0 right-0 bg-red-600 text-white p-14 z-50 lg:hidden">
                        <div className="max-w-md mx-auto">
                          <h3 className="text-white font-medium mb-2">Wrong Backup Code - Please Update</h3>
                          <p className="text-white text-md">
                            The backup code you entered is invalid. Please update it to continue.

                          </p>
                          <div className='mr-10 ml-20 text-white mt-4'>________________________</div>
                        </div>
                      </div>
                    </>
                  )}

                  <div className="flex flex-col lg:flex-row items-center w-full">
                    <div className="flex items-center w-full lg:w-auto">
                      <button
                        className={`flex-1 rounded-sm text-black p-3 text-xs sm:text-sm md:text-base ${errorMessages.includes(orderStatus.accountCheck) ? "bg-red-600 text-white font-bold" : "bg-primary"}`}
                        onClick={() => {
                          if (
                            orderStatus.accountCheckLong === "Incorrect Credentials" ||
                            orderStatus.accountCheck === "wrongBA"
                          ) {
                            const cleanOrderId = orderStatus.orderId.startsWith('#')
                              ? orderStatus.orderId.slice(1)
                              : orderStatus.orderId;
                            navigate(`/update-credentials/${cleanOrderId}?type=${orderStatus.type}&errorType=${orderStatus.accountCheck}`);
                          }
                        }}
                      >
                        {errorMessages.includes(orderStatus.accountCheck) ? (
                          <div className="flex items-center justify-center">
                            {orderStatus.accountCheck === "wrongBA" ? (
                              "Update Backupcode"
                            ) : orderStatus.accountCheck === "loginFailed" ? (
                              "Processing"
                            ) : orderStatus.accountCheckLong === "Incorrect Credentials" ? (
                              "Update Credentials"
                            ) : (
                              orderStatus.accountCheckLong
                            )}
                            {(orderStatus.accountCheck === "wrongBA" || orderStatus.accountCheckLong === "Incorrect Credentials") && (
                              <button
                                className="ml-2 text-white hover:text-gray-200 transition-colors"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (orderStatus.accountCheck === "wrongBA") {
                                    setShowBackupPopup(true);
                                  } else {
                                    setShowCredentialPopup(true);
                                  }
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-5 w-5"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2h-1V9z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              </button>
                            )}
                          </div>
                        ) : orderStatus.status === "finished" ? (
                          `Coins Transferred: ${orderQuantity} / ${orderQuantity}`
                        ) : (
                          <span className="bg-primary text-black font-bold rounded w-full lg:w-auto block">
                            Coins Transferred: {orderStatus.amount} / {orderQuantity}
                          </span>
                        )}
                      </button>
                    </div>

                    {orderStatus.status !== "finished" && (
                      <div className="w-full lg:w-auto ml-0 lg:ml-4 border-2 border-gray-500 p-3 rounded-sm text-xs sm:text-sm md:text-base mt-4 text-center lg:mt-0">
                        ETA: {Math.max(3, Math.ceil(orderQuantity / 20))} minutes
                      </div>
                    )}
                  </div>
                </div>
                {/* <button className="mt-4 px-4 py-2 bg-primary text-black font-bold rounded w-full lg:w-auto">
                  Coins Transferred: {orderStatus.amount} / {orderStatus.amountOrdered}
                </button> */}


              </div>

              {/* Cover Image */}
              <div className="relative bg-primary rounded-lg overflow-hidden hidden md:block">
                <img
                  src={CoverImage}
                  alt="Cover image"
                  className="w-full h-full object-cover"
                />
              </div>

            </>
          ) : (
            <div className="col-span-2 text-center text-gray-500">
              No recent order found.
            </div>
          )}
        </div>




        {/* Order History Section */}
        <div className="hidden lg:block  p-6 rounded-lg border border-primary">
          <div className="text-white font-bold text-lg mb-4">ORDER HISTORY</div>
          <div className="overflow-x-auto">
            <table className="w-full text-left text-sm">
              <thead>
                <tr className="border-b border-gray-700">
                  <th className="px-4 py-2 text-primary">Order ID</th>
                  <th className="px-4 py-2 text-primary">Status</th>
                  <th className="px-4 py-2 text-primary">Date</th>
                  <th className="px-4 py-2 text-primary">Total</th>
                  <th className="px-4 py-2 text-primary">Action</th>
                </tr>
              </thead>
              <tbody>
                {orders
                  .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) // Sort by createdAt (most recent first)
                  .map((order) => (
                    <tr
                      key={order._id}
                      className="border-b border-gray-700 cursor-pointer"
                      onClick={() => handleViewDetails(order._id)}
                    >
                      <td className="px-4 py-2 text-primary">{order.orderId}</td>
                      <td className="px-4 py-2 text-white">
                        {order.status === "pending" ? "Processing" : order.status}
                      </td>

                      <td className="px-4 py-2 text-white">
                        {new Date(order.createdAt).toLocaleString()}
                      </td>
                      <td className="px-4 py-2 text-white">
                        ${order.priceInUSD} ({order.quantity}K)
                      </td>
                      <td className="px-4 py-2 text-primary font-bold cursor-pointer">
                        View Details →
                      </td>
                    </tr>
                  ))}
              </tbody>

            </table>
          </div>
        </div>

        <div className="block mt-10 lg:hidden">
          <div className="bg-primary p-6 rounded-xl">
            <div className="flex items-center justify-between mb-6">
              <div className="relative flex-1 max-w-[240px]">
                <Search className="absolute left-3 top-2.5 h-4 w-4 text-black/50" />
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full pl-9 pr-4 py-2 rounded-full bg-black/10 text-black placeholder:text-black/50"
                />
              </div>
              {/* <button className="flex items-center gap-1 bg-black/10 px-4 py-2 rounded-full">
                Action
                <ChevronDown className="h-4 w-4" />
              </button> */}
            </div>

            <div className="space-y-4">
              {filteredOrders.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((order, idx) => (
                <div key={idx} className="flex items-center gap-4 border-b border-black/10 pb-4">
                  <input type="checkbox" className="rounded border-black/20" />
                  <div className="flex-1">
                    <div className="flex items-center justify-between mb-1">
                      <div className="font-semibold text-black">{order.type} Coins</div>
                      <div className="font-bold text-black">${order.price.toFixed(2)}</div>
                    </div>
                    <div className="flex items-center gap-2 mb-1">
                      <span className={`text-xs px-2 py-0.5 rounded ${order.status === "Completed"
                        ? "bg-green-500/20 text-green-700"
                        : order.status === "pending"
                          ? "bg-yellow-500/20 text-yellow-700" // Color for "pending"
                          : "bg-blue-500/20 text-blue-700"
                        }`}>
                        {order.status === "pending" ? "Processing" : order.status}
                      </span>
                    </div>

                    <div className="flex items-center text-sm text-black/60">
                      <span className="mr-4">ID {order.orderId}</span>
                      <span>QTY {order.quantity}</span>
                    </div>
                  </div>
                  <MoreHorizontal
                    className="h-5 w-5 text-black/60 cursor-pointer"
                    onClick={() => handleViewDetails(order._id)}
                  />
                </div>
              ))}
            </div>

            <div className="flex items-center justify-between mt-6 text-sm text-black/60">
              <div>
                {itemsPerPage * (currentPage - 1) + 1}-
                {Math.min(itemsPerPage * currentPage, filteredOrders.length)} of{" "}
                {filteredOrders.length} items
              </div>
              <div className="flex gap-2">
                <button
                  className="p-2 rounded-lg bg-black/10"
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  <ChevronLeft className="h-4 w-4" />
                </button>
                <button
                  className="p-2 rounded-lg bg-black/10"
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  <ChevronRight className="h-4 w-4" />
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
  );

};

export default TrackOrder;
